import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../hooks/redux';
import { hideToast } from '../../../store/slices/toastSlice';
import { ToastIcon, XCloseModal } from '../../../icons/SvgIcons';

export function GlobalToast() {
  const dispatch = useAppDispatch();
  const { show, message, type } = useAppSelector((state) => state.toast);

  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        dispatch(hideToast());
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [show, dispatch]);

  if (!show) return null;

  const getBackgroundColor = () => {
    switch (type) {
      case 'success':
        return 'bg-cyan-50';
      case 'error':
        return 'bg-rose-50';
      case 'warning':
        return 'bg-orange-50';
      case 'info':
        return 'bg-blue-50';
      default:
        return 'bg-blue-50';
    }
  };

  const getIconColor = () => {
    switch (type) {
      case 'success':
        return '#0DBC9B';
      case 'error':
        return '#F43F5E';
      case 'warning':
        return '#F97316';
      case 'info':
        return '#3B82F6';
      default:
        return '#3B82F6';
    }
  };

  return (
    <div className="absolute bottom-16 left-[125px] 2xl:left-[265px] z-[9999]">
      <div
        className={`flex gap-4 items-center justify-between min-w-96 max-w-2xl h-14 p-4 rounded-lg shadow-lg ${getBackgroundColor()}`}
      >
        <div className="flex items-center gap-4 text-sm text-gray-950 font-medium">
          {ToastIcon(type, getIconColor())}
          {message}
        </div>
        <button
          id="global-toast-close-button"
          data-testid="global-toast-close-button"
          onClick={() => dispatch(hideToast())}
        >
          {XCloseModal()}
        </button>
      </div>
    </div>
  );
}
